import { Box, BoxProps, useTheme } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { HEADER_CONFIG, NAVBAR_CONFIG } from "configs/app.config";
import useAppTheme from "hooks/useAppTheme";

const SPACING = 24;

interface MainProps extends BoxProps {
  fullWidth?: boolean;
}

export default function Main({ fullWidth, children, sx, ...other }: MainProps) {
  const { themeLayout } = useAppTheme();
  const theme = useTheme();
  const isNavHorizontal = themeLayout === "horizontal";

  const isNavMini = themeLayout === "mini";

  const isDesktop = useResponsive("up", "lg");

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          backgroundColor: theme.palette.background.neutral,
          pt: `${HEADER_CONFIG.MOBILE_HEIGHT + SPACING}px`,
          pb: `${HEADER_CONFIG.MOBILE_HEIGHT + SPACING}px`,
          ...(isDesktop && {
            px: 2,
            pt: `${HEADER_CONFIG.DASHBOARD_DESKTOP_HEIGHT + 80}px`,
            pb: `${HEADER_CONFIG.DASHBOARD_DESKTOP_HEIGHT + SPACING}px`,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        backgroundColor: theme.palette.background.neutral,
        pt: `${HEADER_CONFIG.MOBILE_HEIGHT + SPACING}px`,
        width: "100%",
        ...(isDesktop && {
          px: 2,
          pt: `${HEADER_CONFIG.DASHBOARD_DESKTOP_HEIGHT + SPACING}px`,
          width: fullWidth ? "100%" : `calc(100% - ${NAVBAR_CONFIG.DASHBOARD_WIDTH}px)`,
          ...(isNavMini && {
            width: fullWidth ? "100%" : `calc(100% - ${NAVBAR_CONFIG.DASHBOARD_COLLAPSE_WIDTH}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
